export default __webpack_public_path__ + "static/media/bg-talk-1.aeae1c0d.png";